import { render, staticRenderFns } from "./AuditCountsPerUser.vue?vue&type=template&id=15fe1dae&scoped=true&lang=pug&"
import script from "./AuditCountsPerUser.vue?vue&type=script&lang=js&"
export * from "./AuditCountsPerUser.vue?vue&type=script&lang=js&"
import style0 from "./AuditCountsPerUser.vue?vue&type=style&index=0&id=15fe1dae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fe1dae",
  null
  
)

export default component.exports